<template>
    <nav id="navbar">
        <router-link to="/" class="app-brand">
            <h1 class="text-center">USED PIANO GALLERY</h1>
        </router-link>
    </nav>
</template>

<script>
export default {};
</script>

<style type="text/scss" lang="scss" scoped>
@import '../styles/variables';
.app-brand {
    display: block;

    padding: 1.5rem 0;

    background: #f7f7f7;

    color: $black;

    &:hover,
    &:active {
        color: $black;
        text-decoration: none;
    }

    h1 {
        font-family: 'Helvetica Neue', sans-serif;
        margin: 0;
        font-weight: 300;
        letter-spacing: .1em;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue